export type IntroPhase = 'revealing' | 'holding' | 'dawn' | 'complete';
export type IntroAction = 'REVEAL_FINISHED' | 'SKIP' | 'HOLD_FINISHED' | 'DAWN_FINISHED';

export function introReducer(phase: IntroPhase, action: IntroAction): IntroPhase {
  if (phase === 'revealing' && (action === 'REVEAL_FINISHED' || action === 'SKIP')) return 'holding';
  if (phase === 'holding' && action === 'HOLD_FINISHED') return 'dawn';
  if (phase === 'dawn' && action === 'DAWN_FINISHED') return 'complete';
  return phase;
}

export function hasDeepLink(hash: string): boolean {
  return hash.length > 1;
}

export function resolveInitialPhase({
  reducedMotion,
  introSeen,
  hash,
}: {
  reducedMotion: boolean;
  introSeen: boolean;
  hash: string;
}): IntroPhase {
  return reducedMotion || introSeen || hasDeepLink(hash) ? 'holding' : 'revealing';
}

export function isIntroSkipKey(event: Pick<KeyboardEvent, 'key' | 'ctrlKey' | 'metaKey' | 'altKey' | 'shiftKey'>): boolean {
  return event.key !== 'Tab' && !event.ctrlKey && !event.metaKey && !event.altKey && !event.shiftKey;
}
